import React from 'react';
import {
    Activity,
    AlertCircle,
    ArrowLeft,
    ArrowRight,
    Atom,
    Award,
    BookOpen,
    Bot,
    Boxes,
    Brain,
    Briefcase,
    Building2,
    Calendar,
    Check,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    Clock,
    Cloud,
    CloudCog,
    Code,
    Code2,
    Coffee,
    Container,
    Cpu,
    Database,
    Download,
    ExternalLink,
    FileCode,
    FileText,
    Filter,
    FolderGit2,
    FolderOpen,
    Gauge,
    GitBranch,
    Github,
    Globe,
    Grid3x3,
    Heart,
    HelpCircle,
    Hexagon,
    Home,
    Info,
    Layers,
    Layout,
    Lightbulb,
    Linkedin,
    Mail,
    MapPin,
    MessageCircle,
    MessageSquare,
    Music,
    Moon,
    Network,
    Palette,
    Phone,
    Quote,
    Radar,
    Rocket,
    RotateCcw,
    Search,
    SearchX,
    Send,
    SendHorizontal,
    Server,
    Settings,
    Share2,
    Shield,
    ShoppingBag,
    ShoppingCart,
    Sparkles,
    Star,
    Target,
    Terminal,
    Timer,
    Trash2,
    TrendingDown,
    TrendingUp,
    Trophy,
    Users,
    X,
    Minus,
    Menu,
    Sun,
    Zap,
} from 'lucide-react';

const iconMap = {
    Activity,
    AlertCircle,
    ArrowLeft,
    ArrowRight,
    Atom,
    Award,
    BookOpen,
    Bot,
    Boxes,
    Brain,
    Briefcase,
    Building2,
    Calendar,
    Check,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    Clock,
    Cloud,
    CloudCog,
    Code,
    Code2,
    Coffee,
    Container,
    Cpu,
    Database,
    Download,
    ExternalLink,
    FileCode,
    FileText,
    Filter,
    FolderGit2,
    FolderOpen,
    Gauge,
    GitBranch,
    Github,
    Globe,
    Grid3x3,
    Heart,
    HelpCircle,
    Hexagon,
    Home,
    Info,
    Layers,
    Layout,
    Lightbulb,
    Linkedin,
    Mail,
    MapPin,
    MessageCircle,
    MessageSquare,
    Music,
    Moon,
    Network,
    Palette,
    Phone,
    Quote,
    Radar,
    Rocket,
    RotateCcw,
    Search,
    SearchX,
    Send,
    SendHorizontal,
    Server,
    Settings,
    Share2,
    Shield,
    ShoppingBag,
    ShoppingCart,
    Sparkles,
    Star,
    Target,
    Terminal,
    Timer,
    Trash2,
    TrendingDown,
    TrendingUp,
    Trophy,
    Users,
    X,
    Minus,
    Menu,
    Sun,
    Zap,
};

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = iconMap?.[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;